<template>
  <div class="min-height-for-section w-100 pt-livetv">
    <div class="container-fluid">
      <div class="row mt-4 mx-3 mb-4">
        <div class="col-12 text-left my-4 px-4">
          <h4>1. General</h4>
          <p>
            1.1 This page tells you the Terms and Conditions of Use on which you
            may make use of our website rtbgo.bn (hereinafter referred to as the
            “Website”), whether as a guest or a registered user. This Website is
            owned and operated by the Government of His Majesty The Sultan and
            Yang Di-Pertuan of Brunei Darussalam (hereinafter referred to as
            “the Government”). Please read these Terms and Conditions of Use
            carefully before you start to use the Website. By using the Website,
            you indicate that you accept these Terms and Conditions of Use and
            that you agree to abide by them. If you do not agree to these Terms
            and Conditions of Use, please refrain from using the Website.
          </p>

          <p>
            1.2 By continuing to use the Website you further agree to not use
            this Website, content and services contained herein for purposes
            that may contravene the rights or restrict the use and benefit of
            the Website and its content and services, including;
          </p>

          <p>
            a) Uploading material that may violate the law could lead to
            criminal behaviour, endangering the public or otherwise violate any
            regulations or laws of the country or international use of material
            which may contravene the rights of writing, ownership, or any right
            of intellectual wealth;
          </p>

          <p>
            b) The use of unauthorised data or access to legal, system or
            network, including any attempt to prove, scan or test the integrity
            of the system or network system;
          </p>

          <p>
            c) The Use of any virus, ‘or any similar applications that can
            damage or disrupt service to any user, host or network, including
            but not limited to “mail bombing’, ‘flooding’, ‘broadcast attacks
            database’ or place any additional burden or unnecessary to the
            system;
          </p>

          <p>
            d) Exploiting any confirmation password or personal safety of users
            of any host, network or account (hacking or intrusion, or trying to
            trespass or hacking); and
          </p>

          <p>
            e) Reselling or providing a website, the contents and services or
            any part from the website to the person or entity for profit or
            otherwise.
          </p>

          <p>
            The Government reserves the right to delete or alter this Website,
            any contents and services contained there that violates the Terms
            and Conditions of Use.
          </p>

          <h4>2. Intellectual Property</h4>
          <p>
            2.1 All content included on the Website, unless uploaded by users,
            including, but not limited to, text, graphics, logos, icons, images,
            sound clips, video clips, data compilations, page layout, underlying
            code and software is the property of the Government, or any other
            relevant third parties. By continuing to use the Website you
            acknowledge that such material is protected by the laws of Brunei
            Darussalam and any other applicable international intellectual
            property legislation.
          </p>

          <p>
            2.2 You may not reproduce, copy, distribute, store or in any other
            fashion re-use material from the Website unless otherwise indicated
            on the Website or unless given express written permission to do so
            by the Government.
          </p>

          <h4>3. Links to Other websites</h4>

          <p>
            This Website may contain links to other sites. Unless expressly
            stated, these sites are not under the control of theGovernment. The
            Government assumes no responsibility for the content of such web
            sites and disclaim liability for any and all forms of loss or damage
            arising out of the use of them. The inclusion of a link to another
            site on this Website does not imply any endorsement of the sites
            themselves or of those in control of them.
          </p>

          <h4>4. Links to this Website</h4>
          <p>
            Those wishing to place a link to this Website on other sites may do
            so only to the home page of the site rtbgo.bn and shall not do so
            without prior permission. Deep linking (i.e. links to specific pages
            within the site) requires the express permission of the Government.
            To find out more please contact us by email at info@rtb.gov.bn.
          </p>

          <h4>5. Privacy</h4>
          <p>
            Use of the Website is also governed by our Privacy Statement which
            is incorporated into these Terms and Conditions of Use by this
            reference. To view the Privacy Policy, please click on the link
            above.
          </p>

          <h4>6. Disclaimers</h4>

          <p>
            6.1 The Government makes no warranty or representation that the
            Website will meet your requirements, that it will be of satisfactory
            quality, that it will be fit for a particular purpose, that it will
            not infringe the rights of third parties, that it will be compatible
            with all systems, that it will be secure and that all information
            provided will be accurate. The Government make no guarantee of any
            specific results from the use of our service.
          </p>
          <p>
            6.2 No part of this Website is intended to constitute advice and the
            content of this Website should not be relied upon when making any
            decisions or taking any action of any kind.
          </p>

          <h4>7. Availability of the Website</h4>
          <p>
            7.1 The Service is provided “as is” and on an “as available” basis.
            The Government gives no warranty that the service will be free of
            defects and/or faults. To the maximum extent permitted by the law
            the Government provides no warranties (express or implied) of
            fitness for a particular purpose, accuracy of information,
            compatibility and satisfactory quality.
          </p>
          <p>
            7.2 The Government accepts no liability for any disruption or
            non-availability of the Website resulting from external causes
            including, but not limited to, ISP equipment failure, host equipment
            failure, communications network failure, power failure, natural
            events, acts of war or legal restrictions and censorship.
          </p>

          <h4>8. Limitation of Liability</h4>
          <p>
            8.1 To the maximum extent permitted by law, The Government accepts
            no liability for any direct or indirect loss or damage, foreseeable
            or otherwise, including any indirect, consequential, special or
            exemplary damages arising from the use of the Website or any
            information contained therein. Users should be aware that the use of
            the Website and it’s content are at their own risk.
          </p>

          <h4>9. No Waiver</h4>
          <p>
            In the event that any party to these Terms and Conditions of Use
            fails to exercise any right or remedy contained herein, this shall
            not be construed as a waiver of that right or remedy.
          </p>

          <h4>10. Variation of Terms and Conditions</h4>
          <p>
            The Government reserves the right to change these Terms and
            Conditions of Use from time to time at its sole discretion. All
            changes will be posted on this page, and your use of this website
            after such changes have beenposted will constitute your agreement to
            the modified Terms and Conditions of Use and all of the changes. You
            should therefore read this page carefully each time you visit this
            Website to review the then current Terms and Conditions of Use.
          </p>

          <h4>11. Notices</h4>
          <p>
            All notices / communications shall be given to us either by post to
            our Premises (see address above) or by email to info@jpm.gov.bn .
            Such notice will be deemed received 3 days after posting if sent by
            first class post, the day of sending if the email is received in
            full on a business day and on the next business day if the email is
            sent on a weekend or public holiday.
          </p>

          <h4>12. Law and Jurisdiction</h4>
          <p>
            These Terms and Conditions of Use and the relationship between you
            and the Government shall be governed by and construed in accordance
            with the laws of Brunei Darussalam and you agree to submit to the
            exclusive jurisdiction of the courts of Brunei Darussalam.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// hls plugin for videojs6
// videojs

import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
export default {
  data: function() {
    return {};
  },
  components: {
    BreadCrumbsHeader,
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 10px 0 0;
  min-height: 80vh;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 768px) {
  .pt-livetv {
    padding: 8px 0 0;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
.bg {
  background: #292929;
  height: auto !important; /* cross-browser */
  height: 100%; /* cross-browser */
  /* margin-bottom: 120px; */
}
.bg_header {
  background: url("../assets/headerbg.png");
  background-size: cover;
}
.bg_text {
  font-family: "Poppins", sans-serif !important;
  font-size: 35px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: 1.75px;
  text-align: center;
  color: #ffffff;
}
.channel_logo {
  padding: 40px 0px;
}
h4 {
  color: #fab900;
  font-family: "Poppins", sans-serif !important;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 22px;
  text-align: left;
  margin: 15px 0;
}
p {
  font-family: "Poppins", sans-serif !important;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 22px;
  color: #cccccc;
  padding: 0 0 10px;
}
@media only screen and (max-width: 480px) {
  .carousel_title {
    font-size: 20px;
  }
  .items_title {
    font-size: 14px;
  }
  .bg_text {
    font-size: 30px;
  }
}
</style>
